import type { GetJobsResponseAction } from 'client/js/redux/domains/FileIngestor/actions/getJobs.action';
import type { ClearJobDetailsAction } from './clearJobDetails';
import type { GetJobByIdRequestAction, GetJobByIdResponseAction } from './getJobById';
import type { QuickValidateResponseAction } from './quickValidate.action';
import type { TriggerJobResponseAction } from './triggerJob.action';
import type { UploadFileResponseAction } from './uploadFile.action';

export * from './triggerJob.action';
export * from './uploadFile.action';
export * from './getJobs.action';
export * from './getJobById';
export * from './quickValidate.action';

export type FileIngestorAction =
  | TriggerJobResponseAction
  | UploadFileResponseAction
  | GetJobsResponseAction
  | GetJobByIdRequestAction
  | ClearJobDetailsAction
  | GetJobByIdResponseAction
  | QuickValidateResponseAction;
